import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  IconButton,
  Box,
  Input,
} from "@mui/material";
import UploadFileIcon from "@mui/icons-material/UploadFile";

export default function ImportSpecLimitDialog({ open, onClose, onImport }) {
  const [selectedFile, setSelectedFile] = useState(null);

  const handleFileChange = (event) => {
    const file = event.target.files?.[0];
    setSelectedFile(file || null);
  };

  const handleImport = () => {
    if (selectedFile) {
      onImport(selectedFile);
      setSelectedFile(null);
      onClose();
    }
  };

  const handleClose = () => {
    setSelectedFile(null);
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Import Specification Limit File</DialogTitle>

      <DialogContent>
        <Box display="flex" flexDirection="column" gap={2} mt={1}>
          <Typography variant="body2" color="text.secondary">
            Upload an Excel (.xls or .xlsx) file containing the specification limits.
          </Typography>

          <Box display="flex" alignItems="center" gap={2}>
            <Button
              component="label"
              variant="outlined"
              startIcon={<UploadFileIcon />}
            >
              Choose File
              <Input
                type="file"
                accept=".xls,.xlsx"
                onChange={handleFileChange}
                sx={{ display: "none" }}
              />
            </Button>

            <Typography variant="body2">
              {selectedFile?.name || "No file selected"}
            </Typography>
          </Box>
        </Box>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose} color="secondary">
          Cancel
        </Button>
        <Button
          onClick={handleImport}
          color="primary"
          variant="contained"
          disabled={!selectedFile}
        >
          Import
        </Button>
      </DialogActions>
    </Dialog>
  );
}
